export default "__VITE_ASSET__5967e2be__"